import type { StyleRule } from '@archipro-design/aria';
import { paginationClassName, buttonClassName } from '@archipro-design/aria';
import { pxToRem, paginationSlotClassNames } from '@archipro-design/aria';

export const TileGridWrapper: StyleRule = () => ({
    padding: 0,
});

export const GridWrapper: StyleRule<{
    tileGap: number;
    rowGap: number;
    smallRowGap?: boolean;
}> = ({ theme, tileGap, rowGap, smallRowGap }) => ({
    columnGap: pxToRem(6),
    rowGap: pxToRem(smallRowGap ? 50 : 60),
    marginBottom: pxToRem(smallRowGap ? 50 : 60),
    [theme.screen.laptop]: {
        columnGap: pxToRem(0),
        rowGap: pxToRem(rowGap),
        margin: pxToRem(tileGap * -1),
        transition: `all 0.3s`,
    },
});

export const PaginationWrapper: StyleRule<{
    totalPages: number;
}> = ({ totalPages, theme }) => {
    return {
        paddingTop: pxToRem(50),
        paddingBottom: pxToRem(38),
        [theme.screen.laptop]: {
            paddingTop: pxToRem(140),
            paddingBottom: pxToRem(56),
            [`& .${paginationClassName}`]: {
                [`& .${paginationSlotClassNames.list}`]: {
                    marginBottom: pxToRem(24),
                },
            },
        },

        ...(totalPages > 6 && {
            [`& .${paginationClassName}`]: {
                width: '91%',
                [`& .${paginationSlotClassNames.list}`]: {
                    // gap not suppoerted on Safari < 14
                    gap: 'unset',
                    '& > *': {
                        margin: `0 ${pxToRem(6)}`,
                    },
                },
            },
        }),
        [theme.screen.laptop]: {
            paddingTop: pxToRem(120),
            [`& .${paginationClassName}`]: {
                width: 'auto',
                [`& .${paginationSlotClassNames.list}`]: {
                    // gap not suppoerted on Safari < 14
                    gap: 'unset',
                    '& > *': {
                        margin: `0 ${pxToRem(12)}`,
                        [`& .${buttonClassName}`]: {
                            padding: 0,
                        },
                        height: '100%',
                    },
                },
            },
        },

        [`& .${paginationSlotClassNames.divider}`]: {
            display: 'none',
        },

        [`& .${paginationSlotClassNames.paginationMetaData}`]: {
            [`&> *:not(:last-child)`]: {
                margin: 0,
            },
        },
    };
};
